import React, { useEffect, useState } from "react";
import "./register.scss";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { Button, TextField, Chip, Autocomplete, Select, MenuItem, InputLabel, Popper, Dialog, DialogTitle, DialogContent, DialogActions, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import {
  useRegisterMutation,
  useGetallergiesQuery,
  useGetChronicDeaseseQuery
} from "../../../utils/apiSlice";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
const Register = () => {
  const [register] = useRegisterMutation();




  const { data: allergiesData, error: allergiesError, isLoading: allergiesLoading } = useGetallergiesQuery(undefined,{
  refetchOnMountOrArgChange: true,
});
  const { data: chronicData, error: chronicError, isLoading: chronicLoading } = useGetChronicDeaseseQuery(undefined,{
  refetchOnMountOrArgChange: true,
});
  const navigate = useNavigate();

  const [chronicids, setChronicIds] = useState([]);
  const [allergiesids, setAllergiesIds] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [verificationMethod, setVerificationMethod] = useState("email"); // Default to email
  const [registerData, setRegisterData] = useState<any>(null);
  const [initialValues, setInitialValues] = useState<any>({
    firstName: "",
    middleName: "",
    lastName: "",
    email: "",
    password: "",
    phoneNumber: "",

    allergyIds: [], // array of numbers
    customAllergies: [""], // array of strings (keep at least one input)

    chronicDiseaseIds: [], // array of numbers
    customChronicDiseases: [""],
  });

  const validationSchema = Yup.object().shape({
    firstName: Yup.string()
      .required("First name is required")
      .min(2, "First name must be at least 2 characters"),

    middleName: Yup.string().nullable(),

    lastName: Yup.string()
      .required("Last name is required")
      .min(2, "Last name must be at least 2 characters"),

    email: Yup.string()
      .required("Email is required")
      .email("Invalid email format"),

    password: Yup.string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .matches(/[0-9]/, "Password must contain at least one number")
      .matches(
        /[@$!%*?&#]/,
        "Password must contain at least one special character"
      ),

    confirmPassword: Yup.string()
      .required("Confirm password is required")
      .oneOf([Yup.ref("password")], "Passwords must match"),

    phoneNumber: Yup.string()
      .required("Phone number is required")
      .matches(/^[0-9]{10}$/, "Phone number must be 10 digits"),
  });



 useEffect(() => {
    if (allergiesData && allergiesData.data) {
      setAllergiesIds(allergiesData.data || []);
    }
    if (chronicData && chronicData.data) {
      setChronicIds(chronicData.data || []);
    }
  }, [allergiesData, chronicData]);

  // Fallback to empty arrays if the data is undefined or empty


  const handleSubmit = async (data: any) => {
    try {
      // ----- Allergies -----
      const allergyIds: number[] = [];
      const customAllergies: string[] = [];

      data.allergyIds.forEach((allergyName: string) => {
        const matched: any = allergiesids.find((item: any) => item.name === allergyName);
        if (matched) {
          allergyIds.push(matched.id);
        } else {
          customAllergies.push(allergyName);
        }
      });

      // ----- Chronic Diseases -----
      const chronicDiseaseIds: number[] = [];
      const customChronicDiseases: string[] = [];

      data.chronicDiseaseIds.forEach((diseaseName: string) => {
        const matched: any = chronicids.find((item: any) => item.name === diseaseName);
        if (matched) {
          chronicDiseaseIds.push(matched.id);
        } else {
          customChronicDiseases.push(diseaseName);
        }
      });

      const registerData = {
        firstName: data.firstName,
        middleName: data.middleName,
        lastName: data.lastName,
        email: data.email,
        password: data.password,
        phoneNumber: data.phoneNumber,
        allergyIds: allergyIds,
        customAllergies: customAllergies,
        chronicDiseaseIds: chronicDiseaseIds,
        customChronicDiseases: customChronicDiseases
      };



      const response: any = await register(registerData).unwrap();

      if (response.success) {
        toast.success("Signup successful");
        setRegisterData(response.data);
        setShowModal(true); // Open the verification modal
        setShowModal(true);
      } else {

        toast.error(
          response?.response?.data?.detail
            ? response?.response?.data?.detail
            : "Signup Error"
        );
      }
    } catch (error: any) {
      if (error?.status == 400) {

        toast.error(error?.data?.message || "Signup error");
      } else {
        toast.error("Error");
      }

    };
  }


  return (
    <div className="container-fluid h-p100 auth-container">
      <div className="row align-items-center justify-content-md-center h-p100">
        <div className="col-12">
          <div className="row justify-content-center g-0">
            <div className="col-lg-5 col-md-5 col-12">
              <div className="rounded10 shadow-lg translucent-card">
                <div className="content-top-agile p-20 pb-0 text-center">
                  <h2>Register a New Membership</h2>
                </div>

                <div className="p-40">
                  <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                  >
                    {({ handleChange, handleBlur, handleSubmit }) => (
                      <Form>
                        {/* Name Row */}
                        <div className="row">
                          <div className="col-md-4">
                            <div className="input-group mb-3">
                              <span className="input-group-text bg-transparent">
                                <i className="ti-user"></i>
                              </span>
                              <Field
                                type="text"
                                name="firstName"
                                className="form-control bg-transparent"
                                placeholder="First Name"
                              />
                              <ErrorMessage
                                name="firstName"
                                component="div"
                                className="text-danger"
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="input-group mb-3">
                              <span className="input-group-text bg-transparent">
                                <i className="ti-user"></i>
                              </span>
                              <Field
                                type="text"
                                name="middleName"
                                className="form-control bg-transparent"
                                placeholder="Middle Name"
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="input-group mb-3">
                              <span className="input-group-text bg-transparent">
                                <i className="ti-user"></i>
                              </span>
                              <Field
                                type="text"
                                name="lastName"
                                className="form-control bg-transparent"
                                placeholder="Last Name"
                              />
                              <ErrorMessage
                                name="lastName"
                                component="div"
                                className="text-danger"
                              />
                            </div>
                          </div>
                        </div>

                        {/* Phone & Email */}
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <div className="input-group mb-1">
                              <span className="input-group-text bg-transparent">
                                <i className="ti-mobile"></i>
                              </span>
                              <Field
                                type="text"
                                name="phoneNumber"
                                className="form-control bg-transparent"
                                placeholder="Phone Number"
                              />
                            </div>
                            <ErrorMessage
                              name="phoneNumber"
                              component="div"
                              className="text-danger mb-3"
                            />
                          </div>

                          <div className="col-md-6">
                            <div className="input-group mb-1">
                              <span className="input-group-text bg-transparent">
                                <i className="ti-email"></i>
                              </span>
                              <Field
                                type="email"
                                name="email"
                                className="form-control bg-transparent"
                                placeholder="Email"
                              />
                            </div>
                            <ErrorMessage
                              name="email"
                              component="div"
                              className="text-danger mb-3"
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">

                            <div className="input-group mb-3 align-items-center">
                              <span className="input-group-text bg-transparent d-flex align-items-center">
                                <i className="ti-pulse"></i>
                              </span>




                              <Field name="chronicDiseaseIds">
                                {({ form }: any) => {
                                  return (
                                    <Autocomplete
                                      clearIcon={null}
                                      className="custm-chips"
                                      multiple
                                      freeSolo
                                      options={chronicData?.data.length ? chronicData?.data?.map((item: any) => item?.name) : []}
                                      value={form.values.chronicDiseaseIds || []}
                                      onChange={(event, newValue) => {
                                        form.setFieldValue("chronicDiseaseIds", newValue);
                                      }}
                                      renderTags={(value: readonly string[], getTagProps) =>
                                        value.map((option: string, index: number) => (
                                          <Chip
                                            variant="outlined"
                                            label={option}
                                            {...getTagProps({ index })}
                                            key={option}
                                          />
                                        ))
                                      }
                                      PopperComponent={(props) => (
                                        <Popper
                                          {...props}
                                          sx={{
                                            maxHeight: '200px',
                                            // overflowY: 'auto',
                                            width: '100%',
                                            zIndex: 9999,
                                          }}
                                          modifiers={[
                                            { name: 'preventOverflow', options: { boundary: 'viewport' } },
                                            { name: 'flip', options: { enabled: false } },
                                            { name: 'offset', options: { offset: [0, -8] } },
                                          ]}
                                          placement="top-start"
                                        />
                                      )}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          variant="outlined"
                                          placeholder="Chronic Diseases"
                                          sx={{
                                            '& .MuiOutlinedInput-root': {
                                              '& fieldset': {
                                                borderColor: '#86a4c3',
                                              },
                                              '&:hover fieldset': {
                                                borderColor: '#80c0ff',
                                              },
                                              '&.Mui-focused fieldset': {
                                                borderColor: '#80c0ff',
                                              },
                                            },
                                            '& .MuiAutocomplete-inputRoot': {
                                              height: '34px',           // Fixed height always
                                              minHeight: '34px',
                                              maxHeight: '40px',         // Prevent any expansion
                                              padding: '4px 8px',        // Consistent inner spacing
                                              flexWrap: 'wrap',
                                              alignContent: 'flex-start',
                                              overflowY: 'auto',         // Scroll only when content overflows
                                              overflowX: 'hidden',
                                              '& .MuiAutocomplete-tag': {
                                                margin: '2px',           // Tight spacing between chips
                                                height: '24px',          // Smaller chips to fit more in 40px
                                              },
                                            },
                                            '& .MuiAutocomplete-input': {
                                              minWidth: '100px',
                                              padding: '4px 0',
                                              margin: '2px 0',
                                            },
                                            '& .MuiAutocomplete-endAdornment': {
                                              position: 'absolute',
                                              right: 8,
                                              top: '50%',
                                              transform: 'translateY(-50%)',
                                            },
                                            // Optional: hide scrollbar until hover (cleaner look)
                                            '& .MuiAutocomplete-inputRoot::-webkit-scrollbar': {
                                              width: '6px',
                                            },
                                            '& .MuiAutocomplete-inputRoot::-webkit-scrollbar-thumb': {
                                              backgroundColor: 'transparent',
                                            },
                                            '& .MuiAutocomplete-inputRoot:hover::-webkit-scrollbar-thumb': {
                                              backgroundColor: 'rgba(0,0,0,0.3)',
                                            },
                                          }}
                                        />
                                      )}
                                      fullWidth
                                    />
                                  );
                                }}
                              </Field>






                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="input-group mb-3 align-items-center">
                            <span className="input-group-text bg-transparent d-flex align-items-center">
                              <i className="ti-alert"></i>
                            </span>

                            <Field name="allergyIds">
                              {({ form }: any) => {
                                return (
                                  <Autocomplete
                                    {...form}
                                    clearIcon={null}
                                    className="custm-chips"
                                    multiple
                                    freeSolo
                                  
                                      options={allergiesData?.data.length ? allergiesData?.data?.map((item: any) => item?.name) : []}
                                    value={form.values.allergyIds || []}
                                    onChange={(event, newValue) => {
                                      form.setFieldValue("allergyIds", newValue);
                                    }}
                                    renderTags={(value: readonly string[], getTagProps) =>
                                      value.map((option: string, index: number) => (
                                        <Chip
                                          variant="outlined"
                                          label={option}
                                          {...getTagProps({ index })}
                                          key={option}
                                        />
                                      ))
                                    }
                                    PopperComponent={(props) => (
                                      <Popper
                                        {...props}
                                        sx={{
                                          maxHeight: '200px',
                                          // overflowY: 'auto',
                                          width: '100%',
                                          zIndex: 9999,
                                        }}
                                        modifiers={[
                                          { name: 'preventOverflow', options: { boundary: 'viewport' } },
                                          { name: 'flip', options: { enabled: false } },
                                          { name: 'offset', options: { offset: [0, -8] } },
                                        ]}
                                        placement="top-start"
                                      />
                                    )}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Allergies"
                                        sx={{
                                          '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                              borderColor: '#86a4c3',
                                            },
                                            '&:hover fieldset': {
                                              borderColor: '#80c0ff',
                                            },
                                            '&.Mui-focused fieldset': {
                                              borderColor: '#80c0ff',
                                            },
                                          },
                                          '& .MuiAutocomplete-inputRoot': {
                                            height: '34px',              // Fixed total height
                                            minHeight: '34px',
                                            maxHeight: '40px',            // Prevent any growth
                                            padding: '4px 8px',          // Reduced padding to fit chips better
                                            flexWrap: 'wrap',
                                            alignContent: 'flex-start',  // Align chips to top
                                            overflowY: 'auto',           // Scroll only when needed
                                            overflowX: 'hidden',
                                            '& .MuiAutocomplete-tag': {
                                              margin: '2px',             // Tighter chip spacing to fit more
                                              height: '24px',            // Smaller chips for better fit
                                            },
                                          },
                                          '& .MuiAutocomplete-input': {
                                            minWidth: '100px',
                                            padding: '4px 0',            // Minimal padding on input
                                            margin: '2px 0',
                                          },
                                          '& .MuiAutocomplete-endAdornment': {
                                            position: 'absolute',
                                            right: 8,
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                          },
                                          // Hide scrollbar thumb when not needed (optional cosmetic)
                                          '& .MuiAutocomplete-inputRoot::-webkit-scrollbar': {
                                            width: '6px',
                                          },
                                          '& .MuiAutocomplete-inputRoot::-webkit-scrollbar-thumb': {
                                            backgroundColor: 'transparent',
                                          },
                                          '& .MuiAutocomplete-inputRoot:hover::-webkit-scrollbar-thumb': {
                                            backgroundColor: 'rgba(0,0,0,0.3)',
                                          },
                                        }}
                                      />
                                    )}
                                    fullWidth
                                  />
                                );
                              }}
                            </Field>



                          </div>
                        </div>

                        {/* Allergic To */}

                        {/* Password Row */}
                        <div className="row">
                          {/* Password */}
                          <div className="col-md-6">
                            <div className="input-group mb-1">
                              <span className="input-group-text bg-transparent">
                                <i className="ti-lock"></i>
                              </span>
                              <Field
                                type="password"
                                name="password"
                                className="form-control bg-transparent"
                                placeholder="Password"
                              />
                            </div>
                            <ErrorMessage
                              name="password"
                              component="div"
                              className="text-danger mb-3"
                            />
                          </div>

                          {/* Confirm Password */}
                          <div className="col-md-6">
                            <div className="input-group mb-1">
                              <span className="input-group-text bg-transparent">
                                <i className="ti-lock"></i>
                              </span>
                              <Field
                                type="password"
                                name="confirmPassword"
                                className="form-control bg-transparent"
                                placeholder="Confirm Password"
                              />
                            </div>
                            <ErrorMessage
                              name="confirmPassword"
                              component="div"
                              className="text-danger mb-3"
                            />
                          </div>
                        </div>

                        {/* Disclaimer */}
                        <div className="checkbox mb-3">
                          <input type="checkbox" id="disclaimer" />
                          <label htmlFor="disclaimer" className="text-muted">
                            This tool is for educational purposes only. Our AI
                            is not a doctor and cannot provide a medical
                            diagnosis. Results are based only on the information
                            you share, which may be incompleted. Please consult
                            a licensed healthcare professional for medical
                            advice or treatment.
                          </label>
                        </div>

                        {/* Register Button */}
                        <div className="text-center">
                          <button
                            type="submit"
                            className="btn btn-primary px-40"
                          >
                            REGISTER
                          </button>
                        </div>

                        <div className="text-center mt-20">
                          <p className="text-center ">
                            Already have an account?
                            <Link to="/login" className="text-danger ms-5">
                              Sign In
                            </Link>
                          </p>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Dialog
        open={showModal}
        maxWidth="xs"
        fullWidth
        className="auth-modal glass-modal" // Use the new class
        PaperProps={{
          // No inline styles needed now, handled by SCSS
        }}
        BackdropProps={{
          style: {
            backgroundColor: 'rgba(0, 0, 0, 0.2)', // Lighter backdrop to show blur
            backdropFilter: 'blur(5px)'
          }
        }}
      >
        <DialogTitle className="text-center pt-30 pb-10">
          <h2 >Verify Your Account</h2>
          <p className="text-muted fs-14 mb-0">Select your preferred verification method</p>
        </DialogTitle>
        <DialogContent className="px-40 pb-30">
          <div className="d-flex flex-column gap-3 mt-3">
            {/* Custom Radio Button - Email */}
            <div
              className={`modal-radio-option d-flex align-items-center cursor-pointer ${verificationMethod === 'email' ? 'selected' : ''}`}
              onClick={() => setVerificationMethod('email')}
            >
              <Radio
                checked={verificationMethod === 'email'}
                onChange={() => setVerificationMethod('email')}
                value="email"
                name="verification-method"
                color="primary"
                className="p-0 me-3"
              />
              <div className="d-flex align-items-center w-100">
                <div className="icon-box bg-white rounded-circle p-2 me-3 shadow-sm">
                  <i className="ti-email text-primary fs-20"></i>
                </div>
                <div>
                  <span className="fw-bold d-block text-dark  label-single-line">Email Address</span>
                  <small className="text-muted opacity-75">{registerData?.email}</small>
                </div>
              </div>
            </div>

            {/* Custom Radio Button - Mobile */}
            <div
              className={`modal-radio-option d-flex align-items-center cursor-pointer ${verificationMethod === 'mobile' ? 'selected' : ''}`}
              onClick={() => setVerificationMethod('mobile')}
            >
              <Radio
                checked={verificationMethod === 'mobile'}
                onChange={() => setVerificationMethod('mobile')}
                value="mobile"
                name="verification-method"
                className="p-0 me-3"
                sx={{
                  color: '#dc3545',
                  '&.Mui-checked': {
                    color: '#dc3545',
                  },
                }}
              />
              <div className="d-flex align-items-center w-100">
                <div className="icon-box bg-white rounded-circle p-2 me-3 shadow-sm">
                  <i className="ti-mobile text-danger fs-20"></i>
                </div>
                <div>
                  <span className="fw-bold d-block text-dark  label-single-line">Mobile Number</span>
                  <small className="text-muted opacity-75">{registerData?.phoneNumber}</small>
                </div>
              </div>
            </div>

          </div>
        </DialogContent>
        <DialogActions className="justify-content-center pb-30 px-40">
          <button
            className="btn btn-verify px-40"
            onClick={() => {
              toast.info(`OTP sent to your ${verificationMethod === 'email' ? 'Email' : 'Mobile Number'}`);
              navigate("/verify-otp", {
                state: {
                  method: verificationMethod,
                  contact: verificationMethod === 'email' ? registerData?.email : registerData?.phoneNumber
                }
              });
            }}
          >
            SEND OTP
          </button>



        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Register;
